import { createUrl } from 'src/utils/createUrl';

export function postRequest(url, data, queryParams = {}) {
  const newUrl = createUrl(url, queryParams);

  return fetch(newUrl.toString(), {
    method: 'post',
    credentials: 'include',
    headers: {
      client_token: 'some_client_token',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
}
